import { msg } from "@lingui/core/macro";
import { Dialog, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Folder, Pencil, Trash2 } from "lucide-solid";
import { Button } from "@/components/ui/button";
import { useI18n } from "@/providers/i18n-provider";

interface GroupOptionsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  groupName: string;
  onRename: () => void;
  onDelete: () => void;
}

export function GroupOptionsDialog(props: GroupOptionsDialogProps) {
  const { t } = useI18n();
  return (
    <Dialog open={props.open} onOpenChange={props.onOpenChange} contentClass="max-w-[320px] p-0">
      <DialogHeader>
        <div class="flex items-center gap-2 pl-2">
          <Folder class="h-4 w-4 opacity-50" />
          <DialogTitle class="text-sm font-bold truncate max-w-[200px]">
            {props.groupName}
          </DialogTitle>
        </div>
      </DialogHeader>

      <div class="p-2 space-y-1">
        <button
          type="button"
          onClick={() => {
            props.onRename();
            props.onOpenChange(false);
          }}
          class="w-full flex items-center gap-3 p-3 rounded-2xl hover:bg-accent transition-colors text-left group cursor-pointer"
        >
          <div class="h-9 w-9 rounded-full bg-primary/10 flex items-center justify-center text-primary group-hover:scale-110 transition-transform">
            <Pencil class="h-4 w-4" />
          </div>
          <div class="font-bold text-sm">{t(msg`Rename group`)}</div>
        </button>

        <button
          type="button"
          onClick={() => {
            props.onDelete();
            props.onOpenChange(false);
          }}
          class="w-full flex items-center gap-3 p-3 rounded-2xl hover:bg-destructive/10 transition-colors text-left group text-destructive cursor-pointer"
        >
          <div class="h-9 w-9 rounded-full bg-destructive/10 flex items-center justify-center text-destructive group-hover:scale-110 transition-transform">
            <Trash2 class="h-4 w-4" />
          </div>
          <div class="font-bold text-sm">{t(msg`Delete group`)}</div>
        </button>
      </div>

      <div class="p-4 bg-muted/20">
        <Button
          variant="ghost"
          class="w-full h-10 font-bold rounded-xl"
          onClick={() => {
            props.onOpenChange(false);
          }}
        >
          {t(msg`Cancel`)}
        </Button>
      </div>
    </Dialog>
  );
}
